// we use this configuration file for any rootstate of any page we add a React app to
import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { analyticsMiddleware } from '../customize/analytics_middleware';

// anywhere were the configureStore function is used, we need to set window.env
const loggerMiddleware = createLogger();
let middleware = [thunkMiddleware, analyticsMiddleware, loggerMiddleware];
middleware = window.env !== 'LOCAL' ? middleware.slice(0, 2) : middleware;

/**
 *
 * @param {*} reducers
 * @param {*} [preloadedState]
 * @returns
 */
export default function configureStore(reducers, preloadedState) {
  return createStore(reducers, preloadedState, applyMiddleware(...middleware));
}
